import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import collegeSlice from './collegeSlice';
import amcSlice from './amcSlice';
import deliveryChallanSlice from './deliveryChallanSlice';
import userSlice from './userSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    colleges: collegeSlice,
    amc: amcSlice,
    deliveryChallan: deliveryChallanSlice,
    users: userSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;